module.exports = "https://cdn.realtymogul.com/static/media/slide_pi_number_current.11b4277b.png";